import { AsYouType, CountryCode } from "libphonenumber-js";
import country from "constants/country.json";

export class PhoneFormatter {
  formatPhone(phone: string, countryCode: string) {
    const countrys = country.find((el) => el.label === countryCode);

    if (!countrys) {
      return countryCode + phone;
    }

    const formatter = new AsYouType(
      (countrys.code ?? "US") as CountryCode
    ).input(phone); // US as default country

    return formatter;
  }
}
